document.addEventListener("alpine:init", () => {
  Alpine.data("themeToggle", themeToggle);
});

window.onSubmit = onSubmit;

async function onSubmit(token) {
  const form = document.getElementById("contact-form");

  if (form.reportValidity()) {
    const formData = new FormData(form);

    const plainFormData = Object.fromEntries(formData.entries());
    const formDataJsonString = JSON.stringify(plainFormData);

    response = await submitForm(formDataJsonString);

    response.status = 200
      ? notify({
          title: "Message sent Succefully 🎉",
          description:
            "Great! I've received your message and will get back to you soon. Thanks for reaching out",
        })
      : notify({
          title: "Oops something went wrong",
          description: "Please try again",
        });

    form.reset();
  }
}

async function submitForm(formDataJsonString) {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: formDataJsonString,
  };
  try {
    const response = await fetch(
      "https://formsubmit.co/5afd458833d737e83b1ab366d6a8839f",
      options
    );

    return response;
  } catch (e) {
    return e;
  }
}

function notify(message) {
  const event = new CustomEvent("notify", {
    detail: {
      message: message,
    },
  });

  window.dispatchEvent(event);
}

function themeToggle() {
  return {
    show: false,
    mode: "system",
    toggleTheme(value) {
      switch (value) {
        case "system":
          this.toggleToSystemMode();

          break;
        case "light":
          this.mode = "light";
          localStorage.theme = "light";
          this.toggleToLightMode();

          break;
        case "dark":
          this.mode = "dark";
          localStorage.theme = "dark";
          this.toggleToDarkMode();

          break;
      }

      this.show = false;
    },
    toggleToDarkMode() {
      document.documentElement.classList.add("dark");
    },
    toggleToLightMode() {
      document.documentElement.classList.remove("dark");
    },
    toggleToSystemMode() {
      this.mode = "system";
      localStorage.removeItem("theme");

      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? this.toggleToDarkMode()
        : this.toggleToLightMode();
    },
    themeSetInLocalStorage() {
      return "theme" in localStorage;
    },
    listenToSytemThemeChanges() {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", ({ matches }) => {
          if (!this.themeSetInLocalStorage()) {
            matches ? this.toggleToDarkMode() : this.toggleToLightMode();
          }
        });
    },
    setInitialTheme() {
      const themeIsDark = localStorage.theme === "dark";
      const systemIsDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;

      !this.themeSetInLocalStorage() || (themeIsDark && systemIsDark)
        ? this.toggleToDarkMode()
        : this.toggleToLightMode();
    },
    init() {
      this.setInitialTheme();
      this.listenToSytemThemeChanges();
    },
  };
}
